import { fetchBlobData } from '../Api';

export const buscarResumoCaixaPdf = async (resumoId, paperWidthMm = 76) =>
    fetchBlobData(`/CaixaResumo/${resumoId}/Pdf`, { paperWidthMm });
